import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Input,
  Button,
  Icon,
  Form,
  TextArea
} from 'semantic-ui-react'
import ConfirmPopup from 'Components/ConfirmPopup'

import ProjectActions from 'Redux/ProjectRedux'
import styles from './EditStyles.js'

class ProjectEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      project: props.activeProject,
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.activeProject !== nextProps.activeProject) {
      this.setState({ project : nextProps.activeProject })
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.deleteData !== prevProps.deleteData) {
      this.props.history.push('/projects')
    }
  }

  onChange = (e) => {
    const { name, value } = e.target
    this.setState(prevState => ({
        project: {
          ...prevState.project,
          [name]: value
        }
      })
    )
  }

  onToggle = () => {
    this.setState(prevState => ({
        project: {
            ...prevState.project,
            sharingEnabled: !prevState.project.sharingEnabled
        }
      })
    )
  }

  onSave = () => {
    const { project } = this.state
    const payload = {
      title: project.title,
      description: project.description,
      sharingEnabled: project.sharingEnabled,
      password: project.password
    }

    // if project name is not empty
    if(project.title) {
      this.props.projectsUpdateRequest(project.id, payload)
    }
  }

  onDelete = () => {
    this.props.projectsDeleteRequest(this.state.project.id)
  }

  render () {
    return (
      <Form>
        <Form.Field>
          <label>Title</label>
          <Input
            fluid
            name='title'
            value={this.state.project.title}
            onChange={this.onChange}
          />
        </Form.Field>
        <Form.Field>
          <label>Description</label>
          <TextArea
            name='description'
            value={this.state.project.description || ''}
            onChange={this.onChange}
          />
        </Form.Field>
        <div className={styles.actionBtns}>
          <Button
            icon
            labelPosition='left'
            primary
            size='small'
            onClick={this.onSave}
            loading={this.props.updateFetching}>
              <Icon name='save' /> Save
          </Button>
          <ConfirmPopup
            trigger={
              <Button
                size='small'
                basic
                color='red'
                loading={this.props.deleteFetching}>
                  Delete
              </Button>
            }
            onConfirm={this.onDelete}
          />
        </div>
      </Form>
    )
  }
}

const mapStateToProps = (state) => ({
  links: state.links.listData,
  projects: state.projects.listData,
  updateFetching: state.projects.updateFetching,
  deleteData: state.projects.deleteData,
  deleteFetching: state.projects.deleteFetching,
  activeProject: state.selections.activeProject
})

const mapDispatchToProps = (dispatch) => ({
  projectsUpdateRequest: (id, updateParams) =>
    dispatch(ProjectActions.projectsUpdateRequest(id, updateParams)),
  projectsDeleteRequest: id =>
    dispatch(ProjectActions.projectsDeleteRequest(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(ProjectEdit)



// WEBPACK FOOTER //
// ./src/Pages/Projects/Edit.js